document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('slider-component').forEach(function (sliderComp) {
    if (sliderComp.id && sliderComp.id.indexOf('GalleryThumbnails') === 0) return;

    var slider = sliderComp.querySelector('[id^="Slider-"]');
    if (!slider) return;

    var buttonWrap = sliderComp.querySelector('.slider-buttons');

    if (!buttonWrap) {
      buttonWrap = document.createElement('div');
      buttonWrap.className = 'slider-buttons';
      sliderComp.appendChild(buttonWrap);
    }

    var counter = buttonWrap.querySelector('.slider-counter');
    if (counter) counter.style.display = 'none';

    var bar = document.createElement('div');
    bar.className = 'view-progress-bar';
    var fill = document.createElement('div');
    fill.className = 'view-progress-bar__fill';
    bar.appendChild(fill);
    buttonWrap.appendChild(bar);

    function updateBar() {
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      var progress = maxScroll > 0 ? (slider.scrollLeft / maxScroll) : 0;
      fill.style.width = (progress * 100) + '%';
    }

    slider.addEventListener('scroll', updateBar);
    updateBar();

    var isDown = false;
    var startX;
    var scrollLeft;

    slider.style.cursor = 'grab';

    slider.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button, a')) {
        return;
      }
      isDown = true;
      slider.style.cursor = 'grabbing';
      startX = e.clientX;
      scrollLeft = slider.scrollLeft;
      slider.setPointerCapture(e.pointerId);
    });

    slider.addEventListener('pointerup', function () {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('pointercancel', function () {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var x = e.clientX;
      var walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
      updateBar();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var headings = document.querySelectorAll('.footer-block--menu .footer-block__heading');
  headings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      if (window.innerWidth > 749) return;
      var block = heading.closest('.footer-block--menu');
      block.classList.toggle('footer-accordion--open');
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('#shopify-section-template--26995411386753__video_6zUqyj');
  if (!section) return;
  var mediaLink = section.querySelector('a.video-section__media-link');
  if (!mediaLink) return;
  mediaLink.setAttribute('href', 'https://artvikstore.com/collections/new-arrivals');
});